module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fancy-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "dollars"
  }, [_vm._v("$" + _vm._s(_vm.dollars))]), _c('div', {
    staticClass: "cents"
  }, [_vm._v(_vm._s(_vm.cents))]), _vm._v(" "), _c('div', {
    staticClass: "currency"
  }, [_vm._v("USD")])]), _vm._v(" "), (_vm.hasDefaultSlot) ? _c('div', {
    staticClass: "price-text"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af9b408","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/fancy-price.vue
// module id = 714
// module chunks = 1